import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ToastController,
  LoadingController,
  ModalController,
  AlertController,
  ActionSheetController,
} from "ionic-angular";

import {
  Item,
  Api,
  Tracking,
  User,
  Reviews,
  Master,
  Assignment,
} from "@providers/asset/index";
import {
  FormItemPage,
  DetailImagePage,
  AssetDocumentsPage,
  DetailItemERPPage,
  AssetReviewsPage,
} from "../";

declare var cordova: any;

@Component({
  selector: "page-detail_item",
  templateUrl: "page.html",
})
export class DetailItemPage {
  item = {
    id: "",
    scm_asset_id: "",
    asset_name: "",
    asset_classification_id: "",
    asset_classification_name: "",
    asset_location_id: "",
    asset_location_name: "",
    asset_old_code: "",
    asset_old_code2: "",
    asset_temp_code: "",
    asset_new_code: "",
    asset_new_code2: "",
    asset_condition_id: "",
    asset_condition_name: "",
    estimated_value: "",
    acquisition_year: "",
    item_amount: 1,
    related_to: "",
    project_code: "",
    no_seri: "",
  };

  images: any = [];
  base_url = "";
  url_img = "";
  tracking = 0;
  akses: any = {};
  fromERPview: any = false;

  base_qr: any = "";

  assign = 0;
  assignment_id = 0;
  assign_type = "";
  item_result_id = 0;
  assignment_result = false;
  data_assignment_all = false;
  assign_param: any;

  item_tracking: any = "";

  detail_perbaikan: any = {};

  constructor(
    public itemApi: Item,
    public api: Api,
    public trackingApi: Tracking,
    public assignmentApi: Assignment,
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public actSheetCtrl: ActionSheetController,
    public userApi: User,
    public reviewApi: Reviews,
    public masterApi: Master
  ) {
    this.akses = this.userApi.akses;
    this.item.id = navParams.get("id");
    this.fromERPview = navParams.get("fromERPview");
    this.url_img = this.api.url + "/client/uploads/";
    this.base_url = this.api.url;
    this.tracking = navParams.get("tracking");

    if (navParams.get("assign") == 1) {
      this.assign = 1;
      this.assignment_id = navParams.get("assignment_id");
      this.assign_type = navParams.get("assign_type");
      if (this.navParams.get("assign_type") == "location") {
        this.assign_param = this.navParams.get("asset_location_id");
      } else if (this.navParams.get("assign_type") == "project") {
        this.assign_param = this.navParams.get("project_code");
      }

      if (navParams.get("data_assignment_all")) {
        this.data_assignment_all = true;
      }
      if (navParams.get("assignment_result") == true) {
        this.assignment_result = true;
      }

      console.log(
        "assignment type/param => ",
        this.assign_type,
        " / ",
        this.assign_param
      );
    }
    if (this.trackingApi.active) {
      this.getItemTracking(this.item.id);
    }
    console.log("assignment result => ", this.assignment_result);

    console.log(trackingApi);
    console.log("from ERP View = ", this.fromERPview);
  }

  ionViewDidEnter() {
    this.getItemByID();
    this.getPerbaikan();
  }

  presentToast(msg) {
    this.toastCtrl
      .create({
        message: msg,
        duration: 3000,
        position: "top",
      })
      .present();
  }

  getItemByID() {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = { id: this.item.id };
    let get: any;
    if (this.assign == 1) {
      get = this.assignmentApi.getItem(params);
    } else {
      get = this.itemApi.get_detail(params);
    }
    get.subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.item = resp.data[0];
          this.getImagesByID();
        } else {
          this.presentToast("Asset belum terdaftar dalam stock opname !");
          this.navCtrl.pop();
        }
        loading.dismiss();
        console.log(resp.data);
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  getItemTracking(id) {
    let params = { asset_id: id };
    this.trackingApi.get_tracked_item(params).subscribe((resp: any) => {
      if (resp.data != "") {
        this.item_tracking = resp.data[0];
      }
      console.log("tracking item => ", this.item_tracking);
    });
  }

  getImagesByID() {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params: any = {
      asset_id: this.item.id,
    };
    let get: any;
    if (this.assign == 1) {
      get = this.assignmentApi.getImages(params);
    } else {
      get = this.itemApi.getImages(params);
    }
    get.subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.images = resp.data;
        }
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  viewImage(rec: any = {}) {
    let profileModal = this.modalCtrl.create(DetailImagePage, {
      url_image: this.url_img + rec.generated_name,
      detail: rec,
      assign: this.assign,
      assignment_result: this.assignment_result,
    });
    profileModal.present();
  }

  nextItem() {
    let data: any = {
      location_id: this.item.asset_location_id,
      asset_item_id: this.item.id,
      created_by: this.userApi.data.employee_id,
    };
    if (this.item_tracking.id > 0) {
      data.id = this.item_tracking.id;
    } else {
      data.act = "scanned";
    }

    this.track_item(data);
  }

  edit() {
    let params: any = {
      id: this.item.id,
    };
    if (this.assign == 1) {
      (params.assign = 1),
        (params.assignment_id = this.assignment_id),
        (params.assign_type = this.assign_type);
    }
    if (this.detail_perbaikan) {
      params.id_perbaikan = this.detail_perbaikan.id;
    }
    if (this.assignment_result == true) {
      this.presentToast("result assignment tidak bisa diedit");
    } else {
      this.navCtrl.push(FormItemPage, params);
    }
  }

  track_item(params) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    this.trackingApi.post_item(params).subscribe(
      (resp: any) => {
        this.presentToast("item scanned");
        this.getItemTracking(this.item.id);
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  add_review() {
    this.navCtrl.push(AssetReviewsPage, {
      asset_id: this.item.id,
      asset_name: this.item.asset_name,
      location_id: this.item.asset_location_id,
      location_name: this.item.asset_location_name,
    });
  }

  printType() {
    const actionSheet = this.actSheetCtrl.create({
      title: "Printer Type",
      buttons: [
        {
          text: "Wi-Fi",
          icon: "wifi",
          handler: () => {
            console.log("Print Via Wifi");
            this.getPrinters("wifi");
          },
        },
        {
          text: "Bluetooth",
          icon: "bluetooth",
          cssClass: "BluetoothIcon",
          handler: () => {
            console.log("Print Via Bluetooth");
            this.getPrinters("bluetooth");
          },
        },
      ],
    });
    actionSheet.present();
  }

  getPrinters(type) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params: any = {
      t: this.item.asset_new_code,
      t_: this.item.asset_new_code2,
      t2: this.item.asset_old_code2,
      sn: this.item.no_seri,
      s: 0,
    };

    let find: any;
    if (type == "wifi") {
      find = cordova.plugins.brotherPrinter.findNetworkPrinters;
    } else {
      find = cordova.plugins.brotherPrinter.findBluetoothPrinters;
    }
    this.masterApi.getBaseQR(params).subscribe(
      (resp: any) => {
        var that = this;
        this.base_qr = resp.image_data_base64;
        find(
          function (printers) {
            if (printers.length > 0) {
              console.log("printers found => ", printers);
              // if(printers.length==1){
              //   this.print(printers[0]);
              // }else{
              loading.dismiss();
              const printerActSheet = that.actSheetCtrl.create({
                title: "Pilih Printer",
              });
              for (let i = 0; i < printers.length; i++) {
                var button = {
                  text: printers[i].model + " - " + printers[i].nodeName,
                  icon: "print",
                  handler: () => {
                    console.log("printer used => ", printers[i]);
                    that.print(printers[i]);
                  },
                };
                printerActSheet.addButton(button);
              }
              printerActSheet.present();
              // }
            } else {
              alert("Printer Not Found !");
              loading.dismiss();
            }
          },
          function (err) {
            console.log(err);
            loading.dismiss();
          }
        );
      },
      (err) => {
        console.log(err);
        loading.dismiss();
      }
    );
  }

  print(printer) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let that = this;

    cordova.plugins.brotherPrinter.setPrinter(
      printer,
      function () {
        cordova.plugins.brotherPrinter.printViaSDK(
          that.base_qr,
          function (statusCode) {
            console.log(statusCode);
            if (statusCode.result) {
              that.presentToast(statusCode.result);
            }
            loading.dismiss();
          },
          function (err) {
            console.log(err);
            loading.dismiss();
          }
        );
      },
      function (err) {
        console.log(err);
        loading.dismiss();
      }
    );
  }

  viewDataERP() {
    if (this.fromERPview == true) {
      this.navCtrl.pop();
    } else {
      this.navCtrl.push(DetailItemERPPage, {
        id: this.item.id,
        fromAppsView: true,
      });
    }
  }

  toAssetDocuments(doc_mod) {
    this.navCtrl.push(AssetDocumentsPage, {
      doc_module: doc_mod,
      asset_id: this.item.id,
      asset_name: this.item.asset_name,
      location_id: this.item.asset_location_id,
      location_name: this.item.asset_location_name,
    });
  }

  getPerbaikan() {
    let params = {
      asset_id: this.item.id,
    };
    this.itemApi.getPerbaikan(params).subscribe((resp: any) => {
      if (resp.data) {
        this.detail_perbaikan = resp.data;
      }
    });
  }

  addToAssignment() {
    let confirmAdd = this.alertCtrl.create({
      title: "Konfirmasi",
      subTitle: "Yakin akan menambahkan item ini ke list assignment anda ?",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          },
        },
        {
          text: "Ok",
          handler: () => {
            let loading = this.loadingCtrl.create({
              content: "Please wait...",
            });
            loading.present();

            let params: any = {
              id: this.item.id,
              assign_type: this.assign_type,
              assign_param: this.assign_param,
            };
            if (this.assign_type == "location") {
              params.asset_location_id = this.assign_param;
            }
            if (this.assign_type == "project") {
              params.project_code = this.assign_param;
            }
            this.assignmentApi.addToAssignmentList(params).subscribe(
              (resp: any) => {
                loading.dismiss();
                this.presentToast(resp.msg);
              },
              (err) => {
                console.log("add to Assignment list error => ", err);
                loading.dismiss();
              }
            );
          },
        },
      ],
    });
    confirmAdd.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/detail_item/page.ts